import { Component } from '@angular/core';
import { faBars, faSignOutAlt } from '@fortawesome/free-solid-svg-icons';
import { ServicioAutenticacion } from '../auth/auth.service';
import { SidebarService } from '../navbar/sidebar.service';
import { LoadingService } from '../services/loading.service';
import { ApiService } from '../services/api.service';
import { ToastService } from '../services/toast.service';
import { environment } from '../../environments/environment';

@Component({
  selector: 'app-topbar',
  templateUrl: './topbar.component.html',
  styleUrl: './topbar.component.css',
})
export class TopbarComponent {
  faBars = faBars;
  faSignOutAlt = faSignOutAlt;
  nombreCompleto: string = '';
  mensajeNotificacion: string = '';
  entorno: string = '';
  mostrarEntorno: boolean = false;

  constructor(
    private authSrv: ServicioAutenticacion,
    private sidebarSrv: SidebarService,
    public loadingSrv: LoadingService,
    private apiSrv: ApiService,
    private toastSrv: ToastService
  ) {}

  cerrarSesion() {
    this.authSrv.cerrarSesion();
  }

  toggleSidebar() {
    this.sidebarSrv.toggleSidebar();
  }

  ngOnInit(): void {
    this.nombreCompleto = this.apiSrv.obtenerNombreUsuario() ?? '';

    if (environment.development) {
      this.entorno = 'DEV';
      this.mostrarEntorno = true;
    } else if (environment.testing) {
      this.entorno = 'TEST';
      this.mostrarEntorno = true;
    } else {
      this.mostrarEntorno = false;
    }
  }
}
